import { Reveal, Eyebrow } from "./Shared";
import { PROCESS } from "@/lib/site";

export default function Process() {
  return (
    <section className="relative overflow-hidden bg-[#0B1F3A] py-24 lg:py-32 grain">
      <div
        className="pointer-events-none absolute -bottom-40 -left-20 h-[500px] w-[500px] rounded-full opacity-15 blur-3xl"
        style={{ background: "radial-gradient(circle, #C8A75D, transparent 70%)" }}
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <Eyebrow dark>How We Work</Eyebrow>
          <h2 className="font-display mt-6 max-w-3xl text-4xl md:text-5xl font-bold tracking-tight leading-[1.1] text-white">
            A clear, considered path from first conversation to lasting growth.
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
          {PROCESS.map((p, i) => (
            <Reveal key={p.step} delay={0.08 * i}>
              <div data-testid={`process-step-${i}`} className="relative">
                <span className="font-display block text-6xl font-extrabold leading-none text-white/10">
                  {p.step}
                </span>
                <div className="mt-5 h-px w-full bg-white/10">
                  <div className="h-px w-10 bg-[#C8A75D]" />
                </div>
                <h3 className="font-display mt-6 text-xl font-bold tracking-tight text-white">
                  {p.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-white/60">
                  {p.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
